module.exports = __webpack_public_path__ + "static/media/burger-menu.d1eda62f.svg";